
import Rotas from "./routes"
import "./app.css"

function App() {
  return (
    <Rotas />
  );
}

export default App;
